import { useQuery } from "@tanstack/react-query";
import { getTaskScheduleQueryKey } from "./queryKeyHelper";
import { createPreviousOnNullPlaceholderDataFn } from "@coworker/apprestructured/src/task-management/services/queryHelper";
import { Schedule } from "../types/Schedule";
import { getTaskSchedule } from "./tasks.service";

export const useTaskSchedule = (taskId: string | null) => {
  return useQuery({
    queryKey: getTaskScheduleQueryKey(taskId),
    queryFn: () => getTaskSchedule(taskId!),
    enabled: taskId !== null,
    placeholderData: createPreviousOnNullPlaceholderDataFn<Schedule>(taskId),
    staleTime: Infinity,
  });
};
